import { render, staticRenderFns } from "./sim.vue?vue&type=template&id=4000576a&scoped=true&"
import script from "./sim.vue?vue&type=script&lang=js&"
export * from "./sim.vue?vue&type=script&lang=js&"
import style0 from "./sim.vue?vue&type=style&index=0&id=4000576a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000576a",
  null
  
)

export default component.exports